import React, { useState } from 'react';
import '../App.css';
import axios from 'axios';
import {
    SERVER_URI,
} from "../utility/config";

function ContactCreatedMessage(props) {
    window.setTimeout(function () {
        props.handleClose();
    }, 1700);
    return (
        <div >
            <h2 className="message_title">Uusi kontakti lisätty</h2>
        </div>
    );
}

function AddContact(props) {
    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState({
        name: '',
        phoneNumber: '',
        email: '',
    })
    const [doesExist, setDoesExist] = useState(false);
    let storage = window.localStorage;
    let userToken = storage.getItem("admin_token")

    const doesContactExist = async (e) => {
        try {
            let phoneNumber = e.target.value
            let doesContactExist = ''
            doesContactExist = await axios.get(`${SERVER_URI}/does_contact_exist/${phoneNumber}`, { headers: { "Authorization": `Token ${userToken}` } })
            let exists = doesContactExist.data.contactExists
            if (exists === false) {
                setUserData({ ...userData, phoneNumber: phoneNumber })
                setDoesExist(false)
            } else {
                alert("Kontakti on jo listalla")
                setDoesExist(true)
            }
        } catch (e) {
            console.log("Error in contact", e)
        }

    }

    const onChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value })
    }

    //Submit
    const doSubmit = async (e) => {
        e.preventDefault()
        const dataToServer = {
            ...userData,
            name: String(userData.name),
            phoneNumber: String(userData.phoneNumber),
            email: String(userData.email),
        }
        const dataToReducer = {
            ...userData,
            name: String(userData.name),
            phoneNumber: String(userData.phoneNumber),
            email: String(userData.email),
        }
        if(doesExist === false) {
            try {
                let result = await axios.post(`${SERVER_URI}/add_contact/`, dataToServer, { headers: { "Authorization": `Token ${userToken}` } })
                props.dispatch({ type: "ADD_CONTACT", data: { newContact: dataToReducer, id: result.data.id } })
                setShow(!show);
            } catch (e) {
                console.log("Error in adding contact", e)
            }
        }else {
            alert("Puhelinnumero ei ole kelvollinen.")
        }
    }

    return (
        <div className="popUp_card">
            <div className="popup-box">
                <div className="box">
                    <span className="close-icon" onClick={props.handleClose}>x</span>
                    {!show && (
                        <div>
                            <h2 className="popUp_title">Lisää kontakti</h2>
                            <form className="add_driver_form" onSubmit={e => doSubmit(e)}>
                                <label className="label_add" htmlFor="name">Nimi:</label>
                                <input type="text" id="name" name="name" onChange={onChange} placeholder="Nimi" required></input><span className="validity"></span> <br className="desktop-break" />
                                <label className="label_add" htmlFor="email">Sähköposti:</label>
                                <input type="email" id="email" name="email" onChange={onChange} placeholder="Sähköposti" required></input><span className="validity"></span> <br className="desktop-break" />
                                <label className="label_add" htmlFor="phoneNumber">Puhelinnumero:</label>
                                <input type="tel" id="phoneNumber" name="phoneNumber" placeholder="Puhelinnumero" onChange={doesContactExist} required></input><span className="validity"></span><br className="desktop-break" />
                                <input type="submit" id="gradient_Button" value="Lisää tiedot" />
                            </form></div>
                    )}
                    {show && <ContactCreatedMessage handleClose={props.handleClose} />}
                </div>
            </div>
        </div>

    );
}

export default AddContact